<template lang="html">
  <div>
    <div class="container" style="border-bottom:none;">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
      >
        <el-col :span="12">
          <div class="grid-content">
            <h3>专题设置</h3>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="form-container">
        <el-form
          ref="nodeForm"
          :model="nodeForm"
          :rules="nodeFormRules"
          label-position="right"
          label-width="120px"
        >
          <el-form-item
            label="整体显示"
            prop="enable"
          >
            <el-switch
              v-if="nodeForm.hasOwnProperty('enable')"
              v-model="nodeForm.enable"
              v-loading="switchLoading"
              element-loading-text="处理中"
              element-loading-spinner="el-icon-loading"
              :disabled="switchLoading"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="轮播速度"
            prop="duration"
          >
            <el-input
              v-if="nodeForm.hasOwnProperty('duration')"
              type="number"
              :min="500"
              :max="120000"
              v-model.number="nodeForm.duration"
              placeholder="多条公告切换时，间隔的秒数"
            >
              <template slot="append">毫秒/张</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="滚动方向"
            prop="direction"
          >
            <el-radio
              v-model="nodeForm.direction"
              label="vertical"
            >纵向</el-radio>
            <el-radio
              v-model="nodeForm.direction"
              label="horizontal"
            >横向</el-radio>
          </el-form-item>
          <el-form-item>
            <!-- <el-button
              type="default"
              @click="resetForm"
            >重置</el-button> -->
            <el-button
              type="primary"
              @click="submitForm"
            >提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../router'
  import { Message } from 'element-ui'
  // import { MessageBox } from 'element-ui'
  import { Tag } from 'element-ui'
  import { Switch } from 'element-ui'
  import { Alert } from 'element-ui'
  // import { Message } from 'element-ui'
  import Vue from 'vue'
  Vue.use(Tag, Switch, Alert)

  export default {
    data() {
      return {
        nodeForm: {},
        nodeFormRules: {
          duration: [
            {
              required: true,
              message: '请设置轮播速度',
              trigger: 'blur'
            },
            {
              type: 'number',
              message: '只能填写数字',
              trigger: 'blur'
            }
          ]
        },
        switchLoading: false,
      }
    },
    watch: {},
    methods: {
      getTopicConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.topicConfig.list(params)
        .then(res => {
          window.console.log("获取到 topic config")
          window.console.log(res)
          if (res.data.count > 0) {
            that.nodeForm = res.data.results[0]
          } else {
            window.console.log("未找到相关配置")
          }
        })
        .catch(err => {
          window.console.log("获取 topic config 有误", err)
        })
      },
      resetForm: function () {
        window.console.log("resetForm")
        this.$refs.nodeForm.resetFields()
      },
      submitForm: function () {
        this.$refs.nodeForm.validate((valid) => {
          if (valid) {
            window.console.log(valid)
            this.$api.topicConfig.update(
              this.nodeForm.id, this.nodeForm
            ).then(res => {
              window.console.log("TopicConfig更新成功")
              window.console.log(res)
              router.replace({
              name: 'ResultSuccess',
              params: {
                title: '成功',
                subTitle: '公告设置已更新',
                action: {
                  title: '返回公告列表',
                  routeName: 'TopicList'
                }
              }
            })
            })
          } else {
            window.console.log(valid)
            Message.error({
              message: `请检查表单填写是否正确、完整`
            })
          }
        })
      },
      // onSwitchChange: function (val) {
      //   window.console.log("SWITCH状态改变")
      //   this.switchLoading = true
      //   window.console.log(this.nodeForm)
      //   this.$refs.nodeForm.validate((valid) => {
      //     if (valid) {
      //       window.console.log("this.nodeForm:")
      //       window.console.log(this.nodeForm)
      //       this.$api.topicConfig.update(
      //         this.nodeForm.id,
      //         this.nodeForm
      //       ).then(res => {
      //         window.console.log(
      //           "topic config 更新成功", res
      //         )
      //         this.switchLoading = false
      //         if (val) {
      //           Message.success({
      //             message: '节目公告已上线'
      //           })
      //         } else {
      //           Message.warning({
      //             message: '节目公告已下线'
      //           })
      //         }
      //       })
      //     } else {
      //       Message.error({
      //         message: `请检查表单填写是否正确、完整`
      //       })
      //     }
      //   })
      // },
      handleClick(row) {
        window.console.log(row);
      },
    },
    mounted () {
      this.getTopicConfig()
    }
  }
</script>

<style lang="css">
  .alert-container {
    margin-bottom: 15px;
  }
  .page-title {
    /* padding-bottom: 15px; */
    border-bottom: 1px solid #ededed;
    /* margin-bottom: 10px; */
  }
  h3 {
    margin: 0;
  }
  .block-container {
    margin-bottom: 15px;
  }
  .right {
    text-align: right;
  }
  .last-item {
    margin-bottom:0;
  }
</style>
